import { useEffect, useState } from 'react';
import config from '../../common/config';
import SvgMovie from '../../../components/SvgMovie';
import './styles/Digest15.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playText, setPlayText] = useState(false);

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);
    } else {
      // 恢复初始化状态
      setDelayPlay(false);
      setPlayText(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <SvgMovie
        src={config.slides[seq].svgMovie}
        play={delayPlay}
        className="full-screen-svg"
        onComplete={(e: any) => {
          setPlayText(true);
        }}
        onDataLoaded={onDataLoaded}
      />
      <div className={`digest ${playText ? 'ani-fade-in' : ''}`}>
        <a href="/docs/react/introduce-cn">
          <button className="btn-play">Let's play Aurum</button>
          <img
            className="img-pointer"
            src={config.getFullUrl('images/pointer.png')}
            alt="go to home"
          />
        </a>
      </div>
    </div>
  );
};

export default Digest;
